import React from 'react';
import { Close as CloseIcon } from '@mui/icons-material';
import { useEditarAntecedentes } from '../../hooks/useEditarAntecedentes'; // 🚀 IMPORTAMOS LA LÓGICA

export default function ModalEditarAntecedentes({ open, onClose, paciente, onSuccess, mostrarToast }) {
    // 1. DELEGAMOS LA RESPONSABILIDAD AL HOOK
    const {
        register,
        handleSubmit,
        onSubmit,
        isSubmitting
    } = useEditarAntecedentes({ open, onClose, paciente, onSuccess, mostrarToast });

    // 2. CONTROL DE VISIBILIDAD (Guard Clause)
    if (!open) return null;

    // Constantes de diseño Tailwind
    const fieldClass = "w-full py-2.5 px-4 bg-slate-50 border border-slate-200 rounded-xl text-slate-700 text-sm font-medium focus:outline-none focus:border-clinica-primary focus:ring-1 focus:ring-clinica-primary transition-all";
    const labelClass = "block mb-1.5 text-xs font-bold text-slate-500 uppercase tracking-wide";

    // 3. RENDERIZADO VISUAL
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
            <div className="w-full max-w-lg bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
                {/* Cabecera */}
                <div className="flex items-center justify-between px-6 py-5 border-b border-slate-100 bg-slate-50/50">
                    <h2 className="text-lg font-black text-slate-900 tracking-tight">Editar Perfil Clínico</h2>
                    <button type="button" onClick={onClose} className="p-2 text-slate-400 hover:text-slate-700 hover:bg-slate-100 rounded-full transition-colors">
                        <CloseIcon fontSize="small" />
                    </button>
                </div>

                {/* Formulario conectado al Hook */}
                <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col flex-1 overflow-hidden">
                    <div className="p-6 overflow-y-auto space-y-5">
                        {/* Alergias */}
                        <div>
                            <label htmlFor="alergias" className={labelClass}>Alergias Conocidas (RAM)</label>
                            <textarea
                                id="alergias"
                                {...register('alergias')}
                                rows={2}
                                className={fieldClass + ' resize-none'}
                                placeholder="Ej. Penicilina, látex, ibuprofeno..."
                            />
                        </div>
                        {/* Antecedentes */}
                        <div>
                            <label htmlFor="antecedentes" className={labelClass}>Antecedentes y Medicación Habitual</label>
                            <textarea
                                id="antecedentes"
                                {...register('antecedentes')}
                                rows={3}
                                className={fieldClass + ' resize-none'}
                                placeholder="Ej. Hipertensión arterial, diabetes tipo 2, Omeprazol 20mg 1-0-0..."
                            />
                        </div>
                    </div>

                    {/* Botonera de Acción */}
                    <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-100 bg-slate-50">
                        <button type="button" onClick={onClose} disabled={isSubmitting} className="px-5 py-2.5 text-sm font-bold text-slate-600 bg-white border border-slate-300 hover:bg-slate-100 rounded-xl">
                            Cancelar
                        </button>
                        <button type="submit" disabled={isSubmitting} className="inline-flex items-center justify-center min-w-[150px] px-5 py-2.5 text-sm font-bold text-white bg-slate-900 hover:bg-slate-800 rounded-xl transition-colors disabled:opacity-50 shadow-sm">
                            {isSubmitting ? (
                                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            ) : (
                                'Guardar Cambios'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}